import { usePreloadedQuery, type PreloadedQuery } from 'react-relay';

import { confluenceTemplateCollectionDetailsContentfulRelayPageQuery } from '@/__generated_contentful__/confluenceTemplateCollectionDetailsContentfulRelayPageQuery.graphql';
import { confluenceTemplatesUnifiedContentfulRelayPageQuery } from '@/__generated_contentful__/confluenceTemplatesUnifiedContentfulRelayPageQuery.graphql';
import { ConfluenceTemplateCollectionDetailsRelayPageQuery } from '@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-collection-details-contentful-relay-page.template';
import { ConfluenceTemplatesUnifiedRelayPageQuery } from '@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template';
import { isUtgTemplateCategory } from '@/templates/software/confluence/templates/confluence-templates-page/src/relay/utils/is-utg-template-category';

import type { OperationType } from 'relay-runtime';

export const GetConfluenceTemplateCollectionDetailsTitleDescription = (
	urlSlug: string,
	queryRef: PreloadedQuery<OperationType> | undefined,
) => {
	const data = usePreloadedQuery<confluenceTemplateCollectionDetailsContentfulRelayPageQuery>(
		ConfluenceTemplateCollectionDetailsRelayPageQuery,
		queryRef as PreloadedQuery<
			confluenceTemplateCollectionDetailsContentfulRelayPageQuery,
			Record<string, unknown>
		>,
	);
	const collection = data.collections?.items.find((collection) => collection?.urlSlug === urlSlug);

	return {
		title: collection?.collectionNameExternal ?? '',
		description: collection?.oneLinerHeadline ?? '',
	};
};

export const GetConfluenceTemplateCategoryTitleDescription = (
	urlSlug: string,
	queryRef: PreloadedQuery<OperationType> | undefined,
) => {
	const data = usePreloadedQuery<confluenceTemplatesUnifiedContentfulRelayPageQuery>(
		ConfluenceTemplatesUnifiedRelayPageQuery,
		queryRef as PreloadedQuery<
			confluenceTemplatesUnifiedContentfulRelayPageQuery,
			Record<string, unknown>
		>,
	);

	// UTG taxonomy categories share this content type but must not resolve a legacy category page.
	const matchingItem = data.categories?.items
		.flatMap((template) => template?.categoryCollection?.items ?? [])
		.find((item) => item?.urlSlug === urlSlug && !isUtgTemplateCategory(item));

	return {
		title: matchingItem?.categoryNameExternal ?? '',
		description: matchingItem?.shortDescriptionOneLiner ?? '',
	};
};
